"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissionTypes = void 0;
var ATOMCHAT = "ATOMCHAT";
var AWS_S3 = "AWS_S3";
var AWS_SES = "AWS_SES";
var AWS_SNS = "AWS_SNS";
var AWS_TEXTRACT = "AWS_TEXTRACT";
var BACKGROUND_TASK = "BACKGROUND_TASK";
var BNG_PAYMENT = "BNG_PAYMENT";
var CHAT_GPT = "CHAT_GPT";
var CHATGPT_CHATBOT_MESSAGING = "CHATGPT_CHATBOT_MESSAGING";
var CODE_EXPORT = "CODE_EXPORT";
var COLLECTION = "COLLECTION";
var COLLECTION_SNAPSHOTS = "COLLECTION_SNAPSHOTS";
var CUSTOM_COMPONENT = "CUSTOM_COMPONENT";
var CUSTOM_DATA_MAPPING = "CUSTOM_DATA_MAPPING";
var DATABASE_EXPORT = "DATABASE_EXPORT";
var DATA_ENCRYPTION = "DATA_ENCRYPTION";
var DATA_FORM_SEARCH_HISTORY = "DATA_FORM_SEARCH_HISTORY";
var DATA_SOURCE = "DATA_SOURCE";
var DATA_VIEW_ACTIVITY_TRACKER = "DATA_VIEW_ACTIVITY_TRACKER";
var DEPLOYMENT_SETTING = "DEPLOYMENT_SETTING";
var DEVELOPER_API = "DEVELOPER_API";
var DOCUSIGN = "DOCUSIGN";
var EVENT = "EVENT";
var EXTERNAL_API = "EXTERNAL_API";
var FACEBOOK_LOGIN = "FACEBOOK_LOGIN";
var FILE_ACTIVITY_TRACKER = "FILE_ACTIVITY_TRACKER";
var FLUID_PAY = "FLUID_PAY";
var IMAGINE_PAY = "IMAGINE_PAY";
var LOAN_MANAGEMENT = "LOAN_MANAGEMENT";
var LOGIN = "LOGIN";
var LOGIN_WITH_BACKENDLESS = "LOGIN_WITH_BACKENDLESS";
var LOGIN_WITH_XANO = "LOGIN_WITH_XANO";
var MAGIC_LINK_LOGIN = "MAGIC_LINK_LOGIN";
var MESSAGING = "MESSAGING";
var MULTI_TENANT_SAAS = "MULTI_TENANT_SAAS";
var NOTIFICATION_SETTING = "NOTIFICATION_SETTING";
var OAUTH_2 = "OAUTH_2";
var PAGE = "PAGE";
var PAGE_SNAPSHOTS = "PAGE_SNAPSHOTS";
var PERMISSIONS_MANAGE = "PERMISSIONS_MANAGE";
var PLAID = "PLAID";
var PROJECT_VERSION = "PROJECT_VERSION";
var PROFILER = "PROFILER";
var PWA_CONFIGURATION = "PWA_CONFIGURATION";
var SNIPPET_SNAPSHOTS = "SNIPPET_SNAPSHOTS";
var SNIPCART = "SNIPCART";
var STRIPE_CONNECT = "STRIPE_CONNECT";
var SYSTEM_ACTIVITY = "SYSTEM_ACTIVITY";
var STRIPE_PAYMENT_METHODS = "STRIPE_PAYMENT_METHODS";
var TWILIO = "TWILIO";
var TWITTER_LOGIN = "TWITTER_LOGIN";
var TWO_FACTOR_AUTHENTICATION = "TWO_FACTOR_AUTHENTICATION";
var USER_ACTIVITY_TRACKER = "USER_ACTIVITY_TRACKER";
var WEBHOOK = "WEBHOOK";
var TEXT_ANONYMIZATION_ACTIVITY_TRACKER = "TEXT_ANONYMIZATION_ACTIVITY_TRACKER";
var SMS_OTP_CONSENT_VALIDATOR = "SMS_OTP_CONSENT_VALIDATOR";
var SMS_OTP_AUTHENTICATOR = "SMS_OTP_AUTHENTICATOR";
var EMAIL_OTP_CONSENT_VALIDATOR = "EMAIL_OTP_CONSENT_VALIDATOR";
var AWS_SIGNATURE = "AWS_SIGNATURE";
var AUDIT_TRAIL = "AUDIT_TRAIL";
var AUDIT_LOG = "AUDIT_LOG";
var EMAIL_OTP_AUTHENTICATOR = "EMAIL_OTP_AUTHENTICATOR";
var TYPESENSE_SEARCH = "TYPESENSE_SEARCH";
var SOCKET_IO = "SOCKET_IO";
var SENDGRID = "SENDGRID";
var FIGMA = "FIGMA";
var SIGNZY_ACCOUNT_AGGREGATOR = "SIGNZY_ACCOUNT_AGGREGATOR";
var SIGNZY_DIGITAL_DOCUMENT_SIGNING = "SIGNZY_DIGITAL_DOCUMENT_SIGNING";
exports.permissionTypes = {
  CUSTOM_COMPONENT: CUSTOM_COMPONENT,
  DATA_SOURCE: DATA_SOURCE,
  DEPLOYMENT_SETTING: DEPLOYMENT_SETTING,
  CODE_EXPORT: CODE_EXPORT,
  EXTERNAL_API: EXTERNAL_API,
  PWA_CONFIGURATION: PWA_CONFIGURATION,
  DEVELOPER_API: DEVELOPER_API,
  DATA_ENCRYPTION: DATA_ENCRYPTION,
  PROJECT_VERSION: PROJECT_VERSION,
  BACKGROUND_TASK: BACKGROUND_TASK,
  DATABASE_EXPORT: DATABASE_EXPORT,
  LOGIN: LOGIN,
  PROFILER: PROFILER,
  SYSTEM_ACTIVITY: SYSTEM_ACTIVITY,
  NOTIFICATION_SETTING: NOTIFICATION_SETTING,
  PAGE_SNAPSHOTS: PAGE_SNAPSHOTS,
  COLLECTION_SNAPSHOTS: COLLECTION_SNAPSHOTS,
  SNIPPET_SNAPSHOTS: SNIPPET_SNAPSHOTS,
  MULTI_TENANT_SAAS: MULTI_TENANT_SAAS,
  AWS_S3: AWS_S3,
  AWS_SES: AWS_SES,
  EVENT: EVENT,
  PAGE: PAGE,
  AWS_TEXTRACT: AWS_TEXTRACT,
  ATOMCHAT: ATOMCHAT,
  COLLECTION: COLLECTION,
  AWS_SNS: AWS_SNS,
  BNG_PAYMENT: BNG_PAYMENT,
  CHAT_GPT: CHAT_GPT,
  CHATGPT_CHATBOT_MESSAGING: CHATGPT_CHATBOT_MESSAGING,
  DATA_FORM_SEARCH_HISTORY: DATA_FORM_SEARCH_HISTORY,
  DATA_VIEW_ACTIVITY_TRACKER: DATA_VIEW_ACTIVITY_TRACKER,
  FACEBOOK_LOGIN: FACEBOOK_LOGIN,
  FILE_ACTIVITY_TRACKER: FILE_ACTIVITY_TRACKER,
  FLUID_PAY: FLUID_PAY,
  IMAGINE_PAY: IMAGINE_PAY,
  CUSTOM_DATA_MAPPING: CUSTOM_DATA_MAPPING,
  LOAN_MANAGEMENT: LOAN_MANAGEMENT,
  LOGIN_WITH_BACKENDLESS: LOGIN_WITH_BACKENDLESS,
  LOGIN_WITH_XANO: LOGIN_WITH_XANO,
  MAGIC_LINK_LOGIN: MAGIC_LINK_LOGIN,
  MESSAGING: MESSAGING,
  OAUTH_2: OAUTH_2,
  PERMISSIONS_MANAGE: PERMISSIONS_MANAGE,
  PLAID: PLAID,
  SNIPCART: SNIPCART,
  STRIPE_CONNECT: STRIPE_CONNECT,
  TWILIO: TWILIO,
  TWITTER_LOGIN: TWITTER_LOGIN,
  TWO_FACTOR_AUTHENTICATION: TWO_FACTOR_AUTHENTICATION,
  USER_ACTIVITY_TRACKER: USER_ACTIVITY_TRACKER,
  DOCUSIGN: DOCUSIGN,
  STRIPE_PAYMENT_METHODS: STRIPE_PAYMENT_METHODS,
  EMAIL_OTP_AUTHENTICATOR: EMAIL_OTP_AUTHENTICATOR,
  TEXT_ANONYMIZATION_ACTIVITY_TRACKER: TEXT_ANONYMIZATION_ACTIVITY_TRACKER,
  WEBHOOK: WEBHOOK,
  SMS_OTP_CONSENT_VALIDATOR: SMS_OTP_CONSENT_VALIDATOR,
  SMS_OTP_AUTHENTICATOR: SMS_OTP_AUTHENTICATOR,
  EMAIL_OTP_CONSENT_VALIDATOR: EMAIL_OTP_CONSENT_VALIDATOR,
  AWS_SIGNATURE: AWS_SIGNATURE,
  AUDIT_TRAIL: AUDIT_TRAIL,
  AUDIT_LOG: AUDIT_LOG,
  TYPESENSE_SEARCH: TYPESENSE_SEARCH,
  SOCKET_IO: SOCKET_IO,
  SENDGRID: SENDGRID,
  FIGMA: FIGMA,
  SIGNZY_ACCOUNT_AGGREGATOR: SIGNZY_ACCOUNT_AGGREGATOR,
  SIGNZY_DIGITAL_DOCUMENT_SIGNING: SIGNZY_DIGITAL_DOCUMENT_SIGNING
};